export default __webpack_public_path__ + "static/media/bannerTourExample2.b6ff240f.svg";